import type { TaskItem } from '~/types/context';

/**
 * Build the "Continue after cutoff" prompt (Phase E2 of the dynamic-credit
 * plan). When the paused build has a plan, append a compact progress note —
 * which steps are already done vs. still remaining — so the resuming turn
 * doesn't spend steps re-deriving what's finished. The restored snapshot +
 * message history already give it the state; this just states it plainly.
 *
 * Returns `base` unchanged when there's no useful plan state to add: no tasks,
 * nothing completed yet, or everything already done.
 */
export function buildResumeContinuation(base: string, tasks?: TaskItem[]): string {
  const done = (tasks ?? []).filter((t) => t.status === 'done');
  const remaining = (tasks ?? []).filter((t) => t.status !== 'done');

  if (done.length === 0 || remaining.length === 0) {
    return base;
  }

  const list = (items: TaskItem[]) => items.map((t) => `- ${t.title}`).join('\n');

  return [
    base,
    '',
    `Progress so far — ${done.length} of ${done.length + remaining.length} planned steps completed.`,
    '',
    'Already completed (do NOT redo these):',
    list(done),
    '',
    'Remaining to finish:',
    list(remaining),
  ].join('\n');
}
